import React from "react";
import { Models } from "@hex-insights/app-modules";
import { NotificationContainer, NotificationRenderProps, PartialKeys, Row } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { MessageGroupArchivePointCreateMutation } from "../../../../Utilities";
import { MessageGroupArchivePointFormValues, MessageGroupArchivePointMutation } from "../../../FormUtilities";

type CreateButtonProps<
	K extends keyof MessageGroupArchivePointFormValues.Create = keyof MessageGroupArchivePointFormValues.Create,
> = {
	formValues: MessageGroupArchivePointFormValues.CreateSubset<K>;
	iconSize?: number;
} & PartialKeys<
	Omit<
		Models.ActionButtonWithConfirmationProps<MessageGroupArchivePointCreateMutation["createMessageGroupArchivePoint"]>,
		"performAction" | "SuccessNotification"
	>,
	"confirmationContent"
>;

export function CreateButton<
	K extends keyof MessageGroupArchivePointFormValues.Create = keyof MessageGroupArchivePointFormValues.Create,
>({
	formValues,
	iconSize = 16,
	confirmationContent = "Are you sure you want to archive this chat?",
	style,
	...props
}: CreateButtonProps<K>) {
	const create = MessageGroupArchivePointMutation.useCreate<K>();
	const applyCreate = React.useCallback(async () => {
		return create(formValues);
	}, [create, formValues]);

	return (
		<Models.ActionButtonWithConfirmation
			performAction={applyCreate}
			confirmationContent={confirmationContent}
			SuccessNotification={SuccessNotification}
			{...props}
			style={style}
		>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
				<Icon.Archive size={iconSize} /> Archive Discussion
			</Row>
		</Models.ActionButtonWithConfirmation>
	);
}

function SuccessNotification(props: NotificationRenderProps) {
	return (
		<NotificationContainer variant="success" {...props}>
			Discussion archived.
		</NotificationContainer>
	);
}
